import Api from '../../service/api'


export type Params<P extends Record<string, any> = Record<string, any>> = P;

type Config = any

export class HttpUtils {
    private static apiInstance: any;

    private static async getApi() {
        if (!HttpUtils.apiInstance) {
            HttpUtils.apiInstance = (await Api.getInstance()).getApi();
        }
        return HttpUtils.apiInstance;
    }

    static async performGet<T = any>(resource: string, config?: Config) {
        const api = await HttpUtils.getApi();

        if (!api) throw new Error('Api não inicializada');
        const { headers, ...params } = config || {};
        const response = await api.get(resource, { params, headers });
        return response.data as T;
    }

    static async performDelete(resource: string, config?: Config) {
        const api = await HttpUtils.getApi();

        if (!api) throw new Error('API não inicializada');
        const { headers, ...params } = config || {};
        const response = await api.delete(resource, { params, headers });
        return response.data;
    }

    static async performPost<T = any>(resource: string, body?: T, config?: any) {
        try {
            const api = await HttpUtils.getApi();

            if (!api) throw new Error('API não inicializada');

            // Extrair headers e params
            const { headers, ...params } = config || {};

            console.log(`Enviando POST para ${resource}`);
            const response = await api.post(resource, body, {
                params,
                headers
            });

            return response.data;
        } catch (error: any) {
            console.error(`Erro na requisição POST para ${resource}:`, error.message);
            if (error.response) {
                console.error('Detalhes do erro:', error.response.data);
            }
            throw error;
        }
    }
    static async performPut<T = any,>(resource: string, body?: T, config?: Config) {
        const api = await HttpUtils.getApi();

        if (!api) throw new Error('API não inicializada');
        const { headers, ...params } = config || {};
        return api.put(resource, body, { params, headers });
    }
}
